import {DTOEmoji, EmojiClient} from "../api/WickedApiClient";
import {Injectable} from "@angular/core";


@Injectable({
  providedIn: "root"
})
export class CustomEmojiService {

  private emojiClient: EmojiClient;

  constructor(emojiClient: EmojiClient) {
    this.emojiClient = emojiClient;
  }

  private _emojis: DTOEmoji[] = null;

  get emojis(): Promise<DTOEmoji[]> {

    const func = (resolve, reject) => {
      if (this._emojis != null) {
        resolve(this._emojis)
      } else {
        this.emojiClient.getEmojis().subscribe((result) => {
          if (result.error && result.error != "") {
            reject(result.error)
          } else {
            this._emojis = result.emojis;
            resolve(result.emojis)
          }
        })
      }
    };
    return new Promise<DTOEmoji[]>(func);

  }

}
